import { Record } from 'immutable'

export const ProTrackRecord = Record({
  id: null,
  name: null,
  label: null,
  activeUsers: 0,
  active: false,
  publicProTrackId: null,
  levels: 0,
  owner: null,
  libraryLevels: 0,
})

export default class ProTrack extends ProTrackRecord {}
